import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import "./Blog.css";

function Blog() {
  return (
    <div className="blog-page">
      <Navbar />
      <div className="blog-top-bar">
        <h3>Articles & Resources</h3>
        {/* <div className="blog-search-box">
          <input
            type="text"
            className="searchTerm"
            placeholder="Search for Articles"
          />
          <i className="fa fa-search searchButton"></i>
        </div> */}
      </div>

      <div className="blog-middle-bar">
        <div className="blog-pic">
          <figure>
            <img
              src="https://cdn.pixabay.com/photo/2021/01/22/16/55/camera-5940588_960_720.jpg"
              alt="blog"
            />
          </figure>
        </div>
        <div className="pic-desc">
          <p style={{ cursor: "pointer" }}>
            Resources &mdash; September 30, 2021
          </p>
          <h1>
            What entry-level DSLR camera to buy for photographers just starting
            out?
          </h1>
          <p>
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore...
          </p>
          <div class="author-wrap">
            <img
              src="https://assets.website-files.com/6155e2af8026fbac93cf8d48/615ce186b110dc03fcf1e785_john-carter-avatar-photographer-x-template.jpg"
              alt=""
            />
            <div>
              <p
                style={{
                  color: "white",
                  fontWeight: "bold",
                  marginTop: "30px",
                  paddingTop: "10px",
                }}
              >
                John Carter
              </p>
              <p>Photographer</p>
            </div>
          </div>
        </div>
      </div>
      <div className="blog-middle-bar">
        <div className="blog-pic">
          <figure>
            <img
              src="https://cdn.pixabay.com/photo/2020/03/09/06/18/camera-4914690_960_720.jpg"
              alt="blog"
            />
          </figure>
        </div>
        <div className="pic-desc">
          <p>Resources - October 12, 2018</p>
          <h1>
            The best new mobile photo editing apps you should try
            out in 2022
          </h1>
          <p>
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore
          </p>
          <div class="author-wrap">
            <img
              src="https://assets.website-files.com/6155e2af8026fbac93cf8d48/615ce186b110dc03fcf1e785_john-carter-avatar-photographer-x-template.jpg"
              alt=""
            />
            <div>
              <p
                style={{
                  color: "white",
                  fontWeight: "bold",
                  marginTop: "30px",
                  paddingTop: "10px",
                }}
              >
                John Carter
              </p>
              <p>Photographer</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog;
